export default {"src":"/_next/static/media/fiat-usd.3ce82d38.svg","height":30,"width":30};